import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta';
import Hero from '../components/Hero';
import CustomersSection from '../components/CustomersSection';
import OnePlatform from '../components/OnePlatform';
import ConnectData from '../components/ConnectData';
import ConnectorsSection from '../components/ConnectorsSection';
import SemanticLayer from '../components/SemanticLayer';
import BuildWithWAI from '../components/BuildWithWAI';
import Deployment from '../components/Deployment';
import AutonomousAgents from '../components/AutonomousAgents';
import DemoVideo from '../components/DemoVideo';
import TaglineBanner from '../components/TaglineBanner';
import SecuritySection from '../components/SecuritySection';
import ConnectivityGuide from '../components/ConnectivityGuide';
import WhyWAI from '../components/WhyWAI';
import PricingSection from '../components/PricingSection';
import ResellersSection from '../components/ResellersSection';

const HomePage: React.FC = () => {
  useRouteMeta('home');
  return (
    <>
      <Hero />
      <CustomersSection />
      <OnePlatform />
      <ConnectData />
      <ConnectorsSection />
      <SemanticLayer />
      <BuildWithWAI />
      <Deployment />
      <AutonomousAgents />
      <DemoVideo />
      <TaglineBanner />
      <SecuritySection />
      <ConnectivityGuide />
      <WhyWAI />
      <PricingSection />
      <ResellersSection />
    </>
  );
};

export default HomePage;
